import { useCohort } from "@/components/user-context/helpers/cohorts";

import { LoggedInDevAIFreeExistingSitesUser } from "./existing-sites-user";
import { LoggedInDevAIFreeNewUser } from "./new-user";

export const LoggedInDevAIFree = () => {
    const cohort = useCohort();

    if (cohort === "new-user") {
        return <LoggedInDevAIFreeNewUser />;
    }

    if (cohort) {
        return <LoggedInDevAIFreeExistingSitesUser />;
    }

    return null;
};
